webpackJsonp([228184769918434],{

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Webpack = __webpack_require__(24);
	
	var _Webpack2 = _interopRequireDefault(_Webpack);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Webpack2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Source Maps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Webpack is configured to generate sourcemaps for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'production'
	      ),
	      ' build, to make debugging production applications easier. They are not generated in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'development'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In development, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'eval'
	      ),
	      ' version is used, which will show you the transpiled version of code, to see what the browser will ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'actually be running'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Relevant Section'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This section of the Webpack config that controls this behavior is shown below:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      devtool: ifProduction(\'source-map\', \'eval\'),\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-webpack-features-source-maps-js-c08e93666835a7b26977.js